import { NextPage } from 'next';
import { useTranslation } from 'react-i18next';

import Layout from 'modules/layout';
import { getBasicStaticProps } from 'utils/page';

const NOTICES = [
  {
    href: 'https://zehitomo-public-static-assets.s3.ap-northeast-1.amazonaws.com/public-notices/第7期決算公告.pdf',
    title: { en: 'Year 7 Financial Statement (JA)', ja: '第7期決算公告' },
  },
  {
    href: 'https://zehitomo-public-static-assets.s3.ap-northeast-1.amazonaws.com/public-notices/第6期決算公告(訂正後).pdf',
    title: { en: 'Year 6 Financial Statement (JA)', ja: '第6期決算公告' },
  },
  {
    href: 'https://zehitomo-public-static-assets.s3-ap-northeast-1.amazonaws.com/public-notices/第5期決算公告.pdf',
    title: { en: 'Year 5 Financial Statement (JA)', ja: '第5期決算公告' },
  },
  {
    href: 'https://zehitomo-public-static-assets.s3-ap-northeast-1.amazonaws.com/public-notices/第4期決算公告.pdf',
    title: { en: 'Year 4 Financial Statement (JA)', ja: '第4期決算公告' },
  },
];

const NoticesPage: NextPage = () => {
  const {
    i18n: { language },
    t,
  } = useTranslation();

  return (
    <Layout language={language}>
      <div className="container notices-container">
        <h1 className="title">{t('staticPages:notices.title')}</h1>
        <ul className="notice-wrapper">
          {NOTICES.map(({ href, title }) => (
            <li key={href}>
              <a href={href} rel="noopener noreferrer" target="_blank">
                {title[language as 'en' | 'ja']}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <style jsx>
        {`
          .notices-container {
            padding-top: 15px;
            padding-bottom: 15px;
            min-height: 380px;
            max-width: 500px;
          }

          .notice-wrapper {
            border: 1px solid #b4b4b4;
            border-radius: 4px;
            margin-bottom: 1rem;
            padding: 1.5rem 2.5rem;
            min-height: inherit;
          }

          .title {
            color: #212121;
            border-bottom: 1px solid #b4b4b4;
            padding-bottom: 0.25rem;
            margin-bottom: 1rem;
          }

          @media screen and (max-width: 768px) {
            .title {
              text-align: center;
              border-bottom: none;
              padding-bottom: 0;
            }
          }
        `}
      </style>
    </Layout>
  );
};

export const getStaticProps = getBasicStaticProps(['staticPages']);

export default NoticesPage;
